import { render, staticRenderFns } from "./UserPromotions.vue?vue&type=template&id=1cf3d404&scoped=true&"
import script from "./UserPromotions.vue?vue&type=script&lang=js&"
export * from "./UserPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3d404",
  null
  
)

export default component.exports